import { Component, OnInit,SimpleChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { Subscription } from 'rxjs';
import { ProjectLayoutComponent } from '../../layouts/project-layout/project-layout.component';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  tb4: boolean = false;
  error: any;
  personalinfo: any;
  isUploadDocument: boolean = false;
  isSignAgreement: boolean = false;
  isOnlineTraining: boolean = false;

  isSignAgreement1: boolean = true;
  isUploadDocument1: boolean = true;
  isOnlineTraining1: boolean = true;
  completed: boolean = false;
  incompleted0: boolean = false;
  incompleted1: boolean = false;
  incompleted2: boolean = false;
  incompleted3: boolean = false;
  isPending: boolean = true;
  isPendingTraining: boolean = false;
  isPendingContract: boolean = false;
  isPendingDoc: boolean = false;
  isInprogressContract: boolean = false;
  isInprogressTraining: boolean = false;

  isPendingPI: boolean = false;
  isCompletedPI: boolean = false;
  isInprogressPI: boolean = false;

  isPendingUD: boolean = false;
  isCompletedUD: boolean = false;
  isInprogressUD: boolean = false;

  isPendingSA: boolean = false;
  isCompletedSA: boolean = false;
  isInprogressSA: boolean = false;

  isPendingOT: boolean = false;
  isCompletedOT: boolean = false;
  isInprogressOT: boolean = false;
  title = '';
  dasboardMga: boolean = false;
  dasboardMga1: boolean = false;
  menuHideButton: boolean=false;
  Type: any;
  activeRoute = '';
  checkOVRInAgencyCode:any='false';
  DisableforGATA: boolean=false;
  DocmoreInfoReq: any;
  ShowReport:any='true';
  constructor(public router: Router, public user: UserService,public PageLayout: ProjectLayoutComponent) {
    this.activeRoute = this.router.url;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd)=> {
      this.activeRoute = event.url;
    })
    this.getDashboard();
   }
  
  ngOnInit(): void {
    //this.getDashboard();
    if(this.router.url=='/dashboard/dashboard-mga' || this.router.url=='/dashboard/mga-details'){
      this.dasboardMga=true;
    }
    else{
      this.dasboardMga=false;
    }    
    if(this.router.url=='/dashboard/steps-status' || this.router.url=='/dashboard/upload-documents' || this.router.url=='/dashboard/personal-info' || this.router.url=='/dashboard/contract-sign' || this.router.url=='/dashboard/online-training'){
      this.dasboardMga1=true;
    }
    else{
      this.dasboardMga1=false;
    }
  }
  tempCall(){
    // setTimeout(()=>{
    //   // this.getDashboard(); 
    //  this.isCompletedPI = true;
    //  window.location.reload()
    // },3000);
  }
  
  openNav() {
    document.getElementById("mySidebar").style.width = "250px";
    document.getElementById("main").style.marginLeft = "250px";
  }

  closeNav() {
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginLeft = "0";
  }
  onTab4() {
    this.tb4 = true;
  }
  titleNavUD:string="";
  titleNavSA:string="";
  titleNavOT:string="";
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
    
        
          this.personalinfo = data.data.leads;
          this.Type = this.personalinfo.type;
          sessionStorage.setItem('leadId', data.data.leads.leadId)
          if(data.data.leads.type == "Office Admin Staff"){
            this.getLeadAgentsCodes();
           }
          if (this.personalinfo.stagesViews != null || undefined) {
            sessionStorage.setItem('stagesViews', JSON.stringify(this.personalinfo.stagesViews))

            if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === true) {

              this.isCompletedPI = true;
              this.titleNavUD=""
            }
            if (this.personalinfo.stagesViews[0].isCompleted === false && this.personalinfo.stagesViews[0].isApproved === false) {

              this.isPendingPI = true;
              this.titleNavUD="Upload Documents will be active once the Personal Info is submitted"
            }
            else if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === false) {

              this.isInprogressPI = true;
              this.titleNavUD="Upload Documents will be active once the Personal Info is submitted"
            }

            if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === true) {
             
              this.isCompletedUD = true
              this.titleNavSA=""
              this.titleNavOT=""
              
            }
            if (this.personalinfo.stagesViews[1].isCompleted === false && this.personalinfo.stagesViews[1].isApproved === false) {
              
              this.isPendingUD = true;
              this.titleNavSA="Sign Agreement will be active once the uploaded Documents are approved"
              this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
            }
            if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === false) {

              this.isInprogressUD = true;
              this.titleNavSA="Sign Agreement will be active once the uploaded Documents are approved"
              this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
            }

            if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === true) {
              
             this.isCompletedSA=true;
             this.titleNavOT=""
            }
            if (this.personalinfo.stagesViews[2].isCompleted === false && this.personalinfo.stagesViews[2].isApproved === false) {
              
              this.isPendingSA=true;
              //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"

            }
            if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === false) {

             
              this.isInprogressSA=true;
              //this.titleNavOT="Online Training will be active once the uploaded Documents are approved"
            }
            if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === true) {
             
              this.isCompletedOT=true;
            }
            if (this.personalinfo.stagesViews[3].isCompleted === false && this.personalinfo.stagesViews[3].isApproved === false) {
              
              this.isPendingOT=true;

            }
            if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === false) {

             
              this.isInprogressOT=true;
            }
           
          }
          //
          this.DocmoreInfoReq=sessionStorage.getItem('DocmoreInfoReq')
          this.DisableforGATA=false
          if((data.data.leads.type=='General Agent' || data.data.leads.type=='Travel Agency Rep' || data.data.leads.type =='Travel Agent') && (this.isCompletedUD == true && this.DocmoreInfoReq=="false")){
            this.DisableforGATA=true
          }
        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;

          }
          else {

            this.error = "Something went wrong. Please Try again later.";
          }

        }, () => { });

  }
  logoNavigate : boolean = false;
  onClickLogo(){
    if(this.isCompletedPI == true && this.isCompletedUD == true && this.isCompletedSA == true && this.isCompletedOT == true)
    {
      this.logoNavigate = true;
      this.router.navigate(['/activated']);
    }
    else
    {
      this.logoNavigate = false;
      this.router.navigate(['/dashboard']);

    }
  }
  menuHide(){
        this.menuHideButton=!this.menuHideButton;
        this.PageLayout.menuhide1();
  }
  agentcodedata=[];
  leadId:any;
  getLeadAgentsCodes(){
    this.leadId=sessionStorage.getItem('leadId');
    this.user.getLeadAgentsCodes(this.leadId).pipe()
    .subscribe(
      data => {
      this.agentcodedata=[];
      for(let i=0;i<data.data.agentCodes.length;i++){
        if (data.data.agentCodes[i].agentCode.toLowerCase().indexOf('ovr') > -1){
          this.agentcodedata.push(data.data.agentCodes[i])
          sessionStorage.setItem('checkOVRInAgencyCode','true');
          this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
        }
      }
      }, error => {
      }, () => { });
  }
  onClickOnlineTraining(){
    
    this.getDashboard();
    setTimeout(() => {
      this.router.navigate(['/dashboard/online-training'])
        .then(() => {
          window.location.reload();
        });
    }, 50);
  }

}
